import { Directive, HostListener } from '@angular/core';

import { Browser } from '@capacitor/browser';

/* eslint-disable */
@Directive({
    selector: '[openLinkInBrowser]',
    standalone: true
})
export class OpenLinkInBrowserDirective {
    constructor() {}

    @HostListener('click', ['$event']) onClick($event: PointerEvent) {
        $event.stopPropagation();
        $event.preventDefault();

        const url = $event.target instanceof HTMLAnchorElement ? $event.target.href : undefined;
        if (url) {
            this.openPage(url);
        }
    }

    openPage(url: string) {
        Browser.open({ url });
    }
}
